import PlaylistActions from './actions';
import * as D from './deps';
import PlaylistReducer from './reducer';
import handlers from './sagas/watchers/index';
import * as utils from './utils';

export default D.createDomainModule({
  name: 'playlist',
  actions: PlaylistActions,
  components: {},
  utils,
  persisted: true,
  reducer: PlaylistReducer,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(handlers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
